var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWinking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.1 94.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e3e80;}.cls-2{fill:#59ac31;}.cls-3{fill:none;stroke:#1e3e80;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.23px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.86,50.95c-.72,0-1.3-.58-1.3-1.3V21.26c0-.72,.58-1.3,1.3-1.3s1.3,.58,1.3,1.3v28.39c0,.72-.58,1.3-1.3,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.47,46.61c0,2.24-1.81,4.05-4.05,4.05s-4.05-1.81-4.05-4.05,1.81-4.05,4.05-4.05,4.05,1.81,4.05,4.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.87,38.2h-13.27c-.83,0-1.51-.68-1.51-1.51s.68-1.51,1.51-1.51h13.27c.83,0,1.51,.68,1.51,1.51s-.68,1.51-1.51,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.79,72.55c-8.33,0-15.98-3-19.95-7.83-.77-.94-.64-2.32,.3-3.09,.94-.77,2.32-.64,3.09,.3,3.11,3.79,9.61,6.23,16.56,6.23s13.2-2.32,16.41-6.06c.79-.92,2.18-1.03,3.1-.23,.92,.79,1.03,2.18,.24,3.1-4.02,4.68-11.59,7.59-19.74,7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.99,38.52l12.62-4.12c.79-.26,1.22-1.11,.97-1.9s-1.11-1.23-1.9-.97l-12.62,4.12c-.79,.26-1.22,1.11-.97,1.9s1.11,1.23,1.9,.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.7,45.63s5.64-3.15,10.63,.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.05,94.1C21.11,94.1,0,72.99,0,47.05S21.11,0,47.05,0s47.05,21.11,47.05,47.05-21.11,47.05-47.05,47.05Zm0-90.72C22.97,3.38,3.38,22.97,3.38,47.05s19.59,43.67,43.67,43.67,43.67-19.59,43.67-43.67S71.13,3.38,47.05,3.38Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinking);
export default __webpack_public_path__ + "static/media/Winking.5f99b01ae6bf051894cfef03edba13ab.svg";
export { ForwardRef as ReactComponent };